import { topicRepository } from "../../../providers/repositories/topicRepository";
import { Topic } from "../entities/Topic";
import { toast } from "react-toastify";
import Logger from "../../../utils/Logger";
import { t } from "i18next";

export const getAllTopicsUseCase = {
    async exec(trainingId: number | string): Promise<Topic[]> {
        try {
            return await topicRepository.getAll(trainingId);
        } catch (error) {
            toast.error(t("action.error"));
            Logger.error("getAllTopicsUseCase", error);
        }
        return [];
    },
};
